// https://github.com/apollographql/apollo-client/issues/1812
export default function (errorMsg: string) {
  return errorMsg.replace('GraphQL error: Error:', ' ').trim()
}